/**
 * Hand-maintained logo-version pairs for the PDP logo-version test.
 *
 * Keyed by the ORIGINAL (grey logo) handle, valued with the UPDATED (new branding) one.
 * The direction is carried by the structure, so it never has to be inferred from a title
 * marker or from created_at, and the two directions cannot disagree — the reverse index is
 * built once in oa-logo-versions-api.js rather than entered twice here.
 *
 * This map WINS over the tag-and-title matching in oa-logo-versions-api.js. A product listed
 * here is paired from this file alone: it needs no multiple-logo-versions tag, and fixing
 * tags or titles in Shopify will not change how it pairs. Remove the entry to hand it back
 * to the automatic matching.
 *
 * What it does NOT override: a product that is preview-launch or coming-soon is still never
 * offered. Listing a pair says the two are the same garment, not that either is sellable.
 */
window.OA_LOGO_VERSION_PAIRS = {
  'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-black':
    'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-black',
  'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-burnt-maroon':
    'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-burnt-maroon',
  'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-plum-brown':
    'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-plum-brown',
  'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-true-blue':
    'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-true-blue',

  'enhancelift-seamless-strappy-sports-bra-with-grey-logo-black':
    'enhancelift-seamless-strappy-sports-bra-new-branding-black',
  'enhancelift-seamless-strappy-sports-bra-with-grey-logo-burnt-maroon':
    'enhancelift-seamless-strappy-sports-bra-new-branding-burnt-maroon',
  'enhancelift-seamless-strappy-sports-bra-with-grey-logo-plum-brown':
    'enhancelift-seamless-strappy-sports-bra-new-branding-plum-brown',
  'enhancelift-seamless-strappy-sports-bra-with-grey-logo-true-blue':
    'enhancelift-seamless-strappy-sports-bra-new-branding-true-blue'
};
